module.exports = __webpack_public_path__ + "img/12.6fed5c94.jpg";